import { useMemo } from 'react';
import { isDisabled } from '@utils/formik';

export const useIsDisabled = <T,>(...args: [...Parameters<typeof isDisabled<T>>, Partial<ReturnType<typeof isDisabled<T>>>?]) => {
  return useMemo(() => ({
    ...isDisabled(args[0], args[1]),
    ...args[2],
  }), [args]);
}
